import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import About from './components/About';
import AllCategories from './components/AllCategories';
import ArticleGrid from './components/ArticleGrid';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import { useEffect } from 'react';

const SITE_URL = 'https://oopbuyspread.mom';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Oopbuy Spreadsheet',
  url: SITE_URL,
  logo: LOGO_URL,
  description: 'Oopbuy Spreadsheet ist die clevere Lösung für organisiertes Online-Shopping. Verwalte deine Einkäufe, vergleiche Preise und spare Zeit mit der innovativen Spreadsheet-Technologie.',
  sameAs: ['https://kaspreadsheet.com'],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['German', 'English'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Oopbuy Spreadsheet',
  url: SITE_URL,
  description: 'Oopbuy Spreadsheet - Die smarte Einkaufs-Spreadsheet-Lösung für Deutschland',
  inLanguage: 'de',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <Navbar />
      <Hero />
      <article>
        <CategoryGrid />
        <About />
        <AllCategories />
      </article>
      <section>
        <ArticleGrid />
      </section>
      <Testimonials />
      <CtaSection />
      <Footer />
    </main>
  );
}